module.exports = __webpack_public_path__ + "static/media/AppleStore.18edc722.png";